import React from "react"
import mount from "core/mount"
import Button from "@kit/design/button"
import Note from "@kit/design/note"

function UnconfirmedSendAddressBanner({ emailSettingsLink }) {
  return (
    <Note type="warning" size="sm" className="!bg-system-yellow-100">
      <p className="flex-grow">
        <strong>
          One or more sending email addresses needs to be confirmed.
        </strong>{" "}
        Confirm an address to start using it for sending.
      </p>
      <Button
        is="plain"
        size="sm"
        href={emailSettingsLink}
        target="_blank"
        className="ml-4 flex-shrink-0 bg-system-yellow-400 hover:bg-system-yellow-500"
      >
        Manage email addresses
      </Button>
    </Note>
  )
}

export { UnconfirmedSendAddressBanner }

mount({ "Account.UnconfirmedSendAddressBanner": UnconfirmedSendAddressBanner })
